
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      imgArray: '', // Array para armazenar os valores img
      defaultImageUrl:
        'https://static.vecteezy.com/system/resources/previews/004/141/669/original/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg',
      WPNews: null,
      overlayNews: false,
    }
  },
  computed: {
    ...mapGetters('noticias', ['newSelected', 'WPSelected']),
  },

  mounted() {
    this.loadNews()
  },
  methods: {
    ...mapActions('noticias', ['fetchNewsWP']),

    async loadNews() {
      this.overlayNews = true
      try {
        const page = 1
        await this.fetchNewsWP(page)
        this.WPNews = this.WPSelected(this.$route.params.slug)
      } catch (error) {
        console.error(error)
      } finally {
        this.overlayNews = false
      }
    },
  },
}
